import styled, { css } from 'styled-components'
import { H3, StyledParagraph } from 'components/shared'

export const Wrapper = styled.div`
  max-width: 560px;
  text-align: center;
  margin: 100px auto 50px;

  ${H3} {
    margin-bottom: 16px;
  }

  ${StyledParagraph} {
    margin-bottom: 24px;
  }
`

export const IconWrap = styled.div`
  ${({ theme }) => css`
    width: 92px;
    height: 92px;
    margin: 0 auto 24px;
    border-radius: 50%;
    background: ${theme.colors.greySemiLight};
    padding: 16px;

    svg {
      height: 100%;
      width: 100%;
    }
  `}
`
